import { BCMSRecord, BCMSStateManagerCRUD, useBCMSContext } from "@bcm-dev/bcms-vite";
import ParticipantsACHPage, { getDefaultData, getDefaultUI } from "components/pages/ParticipantsACHPage";
import Classes, { Participant } from "model";

export default function CaptureACHParticipantsMainNewAdded(props) {
    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);
    const participant = Participant.init({ id: Participant.nextID(), nickname: "tjefferson", participantType: "standard", accountType: "Checking", status: "active" });
    const participants = [ ...getDefaultData().participants, participant ];
    const data = BCMSStateManagerCRUD.init({ participant: participant })
    .update([ "participant", "participantName" ], "Thomas Jefferson")
    .update([ "participant", "participantEmail" ], "tjefferson@presidentsinc.com")
    .update([ "participant", "nickname" ], "TJefferson")
    .update([ "participant", "institutionName" ], "PRESIDENTS BANK AND TRUST")
    .update([ "participant", "routing" ], "999888766")
    .update([ "participant", "uniqueID" ], "5671234891")
    .update([ "participant", "number" ], "1234567")
    .update([ "participant", "confirmedAccountNumber" ], "1234567")
    .update([ "participant", "accountType" ], "Checking")
    .update([ "participant", "status" ], "Active")
    .update([ "participant", "group" ], "Employee")
    .update([ "participant", "distributePayments" ], true)
    .update([ "participants" ], participants)
    .submit();



    const ui = BCMSStateManagerCRUD.init(getDefaultUI())
    .update([ "showParticipantIsAddedBanner" ], true)
    .submit();

    return <ParticipantsACHPage data={ data } ui={ ui } className="for-capture"/>
}